module.exports = __webpack_public_path__ + "static/media/m-footer-bg.43443608.svg";